import AssetPositionAreaRow from "./AssetPositionAreaRow";
import AssetPositionChangeButton from "./AssetPositionChangeButton";
import { MemberType, PlayerType, PositionType } from '../Type/TeamType';
import { Typography } from '@material-ui/core';
import { EffectSkilePositionType } from "../assetSettingModal/hooks/AssetSettingModalType";
import { mainContentColor } from '../../components/lib/Color';

type Props = {
    member: MemberType
    onAssetPositionChangeButtonTopClick: () => void,
    onAssetPositionChangeButtonBottomClick: () => void
}

const AssetPositionArea = ({ member, onAssetPositionChangeButtonTopClick, onAssetPositionChangeButtonBottomClick }: Props) => {
    const makeEffectSkilePositionLabel = (effectSkilePosition: EffectSkilePositionType, member: MemberType) => {
        switch (effectSkilePosition) {
            case "ExtensionLeft":
                return <>
                    <img
                        src={`/images/extensions/${member?.leftExtension?.id}.png`}
                        style={{ width: 32, height: 32, background: mainContentColor, marginRight: "10px" }}
                    />
                    <Typography display="inline" variant="h5" style={{ color: "white", position: "relative", textAlign: "left", background: mainContentColor }}>
                        {member.leftExtension?.name}
                    </Typography>
                </>;
            case "ExtensionRight":
                return <>
                    <img
                        src={`/images/extensions/${member?.rightExtension?.id}.png`}
                        style={{ width: 32, height: 32, background: mainContentColor, marginRight: "10px" }}
                    />
                    <Typography display="inline" variant="h5" style={{ color: "white", position: "relative", textAlign: "left", background: mainContentColor }}>
                        {member.rightExtension?.name}
                    </Typography>
                </>;
            case "ArtSkill":
                return <>
                    <Typography display="inline" variant="h5" style={{ color: "white", position: "relative", textAlign: "left", background: mainContentColor }}>
                        {member.artSkill?.name}
                    </Typography>
                </>;
        }
    }

    return (
        <>
            <AssetPositionAreaRow position={1} label={makeEffectSkilePositionLabel(member.effectSkilePositionTop, member)} />
            <AssetPositionChangeButton onClick={onAssetPositionChangeButtonTopClick} />
            <AssetPositionAreaRow position={2} label={makeEffectSkilePositionLabel(member.effectSkilePositionCenter, member)} />
            <AssetPositionChangeButton onClick={onAssetPositionChangeButtonBottomClick} />
            <AssetPositionAreaRow position={3} label={makeEffectSkilePositionLabel(member.effectSkilePositionBottom, member)} />
        </>
    );
}

export default AssetPositionArea;